import { isUndefined } from 'lodash-es';
import { useContext } from 'react';

import { XYChartAnnotationsDataContext } from '../context/XYChartAnnotationsData.context.js';

export const useXYChartAnnotationsData = () => {
  const context = useContext(XYChartAnnotationsDataContext);
  if (isUndefined(context)) {
    throw new Error(
      'useXYChartAnnotationsData must be used within a XYChartAnnotationsDataContext.Provider',
    );
  }
  return context;
};
